const ACCESTOKENS = {
    listTokens: "Lista de tokens",
    newTokens: "Crear Token",
    user: "Usuario",
    token: "Token",
    dateExpired: "F. Expiración",
    company: "Compañía",
    acctions: "Acciones",

    "delete": "Eliminar",
    edit: "Editar",
    accept: "Aceptar",
    cancel: "Cancelar",
    update: "Actualizar",

    titleAlert: "Eliminar token",
    messageAlert: "Desea eliminar el token?",

    searchUser: "Buscar usuario...",
    users: "Usuarios",
    created: "Creado",
    Email: "Email",

    dateEspirated: "Fecha de expiración",
    phone: "Teléfono",
    Role: "Rol",
    createToken: "Crear Token",
    new: "Nuevo",

    emptyTokens: "No hay tokens registrados.",
    listTokens: "Lista de tokens",
    dateEpiredCompany1: `La fecha de contratación de la compañía **`,
    dateEpiredCompany2: `** ha expirado, debe actualizarla.`,

    tokenIsUpdated: "Se ha actualizado el token",
    errorToUpdate: "Error al actualizar",
    CanNotUpdate: "No se pudo actualizae el token.",
    selectedUser: "Seleccione un usuario",

    tooltip: {
        all: "Todos",
        active: "Activos",
        expired: "Vencidos"
    }


}

export default { ACCESTOKENS };